module.exports = {
    apiBaseUrl : {        
        logApi : "http://127.0.0.1:3001",
        logApiID: "KhesMZzUQG78EDx8T0HOl3DSb8aBuBNIDXAldiNb",  
        claudeApi: "http://127.0.0.1:3001",
        claudeApiID: "KhesMZzUQG78EDx8T0HOl3DSb8aBuBNIDXAldiNb",
        kendraWebSocket: "wss://njh9j38275.execute-api.us-east-1.amazonaws.com/dev/",
        // AgentCore front door origin, no trailing slash. See apiConfigDev.js.
        //
        // Note there is no local loopback story here: like kendraWebSocket
        // above, this points at a deployed environment. Cookie auth needs
        // Secure + SameSite=Strict, so a plain http://localhost origin will
        // not receive the session cookie.
        agentApi: ""
    },
    features: {
        useKendraAPI: true,  // Enable Kendra API for local testing
        useHttpStreaming: false
    },
    cognito : {
        authority: "https://cognito-idp.us-east-1.amazonaws.com/us-east-1_EGijSFBEl",
        clientId : "p3a5qiemf21n3m0j2b0o70dn9",
        cognitoDomain : "https://tns-iq-dev.auth.us-east-1.amazoncognito.com",
        logoutUri: "http://localhost:3000/logout"
    },
    checkout : {
        checkoutApi : "http://localhost:8080/api/",
        hostedCheckoutEndpoint: "https://checkouttest.dev.paymentgateway.tnsi.com/uat/dist/index.js",
        terminalSaleEndpoint: "http://localhost:8080/api/terminal/sale"
    }
}

